import api from "services/api";

// Get attendance records
export const getAttendanceRecords = async (params) => {
  return api.get("/v1/api/admin/attendance-records", {
    params,
  });
};
